import { render, staticRenderFns } from "./StepFeatures.vue?vue&type=template&id=6dfc3c3e&scoped=true&"
import script from "./StepFeatures.vue?vue&type=script&lang=js&"
export * from "./StepFeatures.vue?vue&type=script&lang=js&"
import style0 from "./StepFeatures.vue?vue&type=style&index=0&id=6dfc3c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc3c3e",
  null
  
)

export default component.exports